// extracted by mini-css-extract-plugin
export default {"modelMail":"styles_modelMail__Xx+FM","buttonSection":"styles_buttonSection__d+gpV","button":"styles_button__dXpv6","button1":"styles_button1__QJL0Z"};